import { mapActions, mapState } from 'vuex'
import { addBookmark, deleteBookmark } from '@/service/member'
import confirm from './index'
export default {
    mixins: [confirm],
    computed: {
        ...mapState(['bookMarks', 'memberInfo', 'userInfo']),
        bookId() {
            const { id, type } = this.info
            const t = this.bookMarks.find(
                item => item.detail.id == id && item.detail.type === type
            )
            return t && t.id
        }
    },
    methods: {
        ...mapActions(['getBookmarks']),
        async _book() {
            try {
                if (!this.memberInfo.id) {
                    this.showConfirm()
                    return
                }
                if (this.bookId) {
                    await deleteBookmark(this.bookId)
                    this.$message.success('取消收藏成功')
                } else {
                    await addBookmark({
                        name: this.info.name,
                        url: window.location.href,
                        detail: {
                            id: this.info.id,
                            type: this.info.type,
                            rId: this.info.rId
                        }
                    })
                    this.$message.success('收藏成功')
                }
                this.getBookmarks(true)
            } catch (error) {
                this.$message.fail(error.message)
            }
        }
    }
}
